import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;

export class NetworkedAttribute extends AbstractBlock {
  constructor() {
    super('networked_attribute', t.to('ネットワーク共有', 'networked'));
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);
    block.appendDummyInput().appendField(t.to('ネットワーク共有', 'networked'));
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);

    const str = CodeSetting.buildAttribute(
      [['networked', `template:#entity-template;attachTemplateToLocal:true;`]],
      attribute
    );
    return [str];
  }
}
